import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Vector",
  d: "M14.8906 0.71875L9 6.52234L3.10935 0.71875L0 3.78215L5.89065 9.58574L0 15.3893L3.10935 18.4527L9 12.6491L14.8906 18.4527L18 15.3893L12.1094 9.58574L18 3.78215L14.8906 0.71875Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }